import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/new-content/importer-telecharger-2.png'


const _withScopeId = n => (_pushScopeId("data-v-0f82df14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data-modal-container" }
const _hoisted_2 = { class: "data-modal-header" }
const _hoisted_3 = { class: "title-container" }
const _hoisted_4 = { class: "button-container" }
const _hoisted_5 = { class: "data-modal-body" }
const _hoisted_6 = { ref: "Table" }
const _hoisted_7 = { class: "table-header" }
const _hoisted_8 = {
  ref: "TableBody",
  class: "table-body"
}
const _hoisted_9 = ["value"]
const _hoisted_10 = ["href", "download"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString($props.Title), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "close-container",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($props.onSubmit($props.selectedData)))
        }, _toDisplayString(_ctx.$t('generic.validate')), 1),
        _createElementVNode("div", {
          class: "close-container",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($props.onClose && $props.onClose(...args)))
        }, _toDisplayString(_ctx.$t('generic.close')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("thead", _hoisted_7, [
          _createElementVNode("tr", {
            ref: "TableHeader",
            class: _normalizeClass({ 'table-header-row': $setup.isSmallTable })
          }, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('generic.keep')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.Data.headers, (item) => {
              return (_openBlock(), _createElementBlock("th", { key: item }, _toDisplayString(item), 1))
            }), 128))
          ], 2)
        ]),
        _createElementVNode("tbody", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.Data.values, (row) => {
            return (_openBlock(), _createElementBlock("tr", {
              ref_for: true,
              ref: "NewDataRow",
              key: row.index,
              class: "new-rows"
            }, [
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  value: row.index,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($props.selectedData) = $event))
                }, null, 8, _hoisted_9), [
                  [_vModelCheckbox, $props.selectedData]
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.data, (value) => {
                return (_openBlock(), _createElementBlock("td", { key: value }, [
                  (typeof value === 'object' && !value.isDownload)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: _normalizeClass(row.index.toString()),
                        href: value[Object.keys(value)[0]],
                        download: Object.keys(value)[0],
                        ref_for: true,
                        ref: "File"
                      }, _toDisplayString(Object.keys(value)[0]), 11, _hoisted_10))
                    : (typeof value === 'object')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "image-container",
                          onClick: ($event: any) => ($setup.DownloadFiles(row.index))
                        }, _hoisted_13, 8, _hoisted_11))
                      : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(value), 1))
                ]))
              }), 128))
            ]))
          }), 128))
        ], 512)
      ], 512)
    ])
  ]))
}